import { CurrencyPipe } from '@angular/common';
import { Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { ArtistProductSummary, ArtistProductsService, ArtistProductsSummaryRequest } from 'src/app/Services/artistproducts.service';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';
import { GalleryPersonlaProduct, GalleryProductService } from 'src/app/Services/Gallery-Products-Service/galleryproduct.service';
import { ImageUtils } from 'src/app/shared/utils/image-utils';

@Component({
    selector: 'show-more-sidepanel',
    templateUrl: './show-more-side-panel.component.html',
    styleUrls: ['./show-more-side-panel.component.css'],
    inputs: ['sidebarVisible', 'artistId'],
    outputs: ['onClosed'],
    standalone: false
})
export class ShowMoreSidePanelComponent implements OnInit {
  public sidebarVisible: boolean = false;
  public onClosed = new EventEmitter<void>();
  public authConfig!: AuthConfig;
  public artistId!: string;
  public filters: ArtistProductsSummaryRequest = {};
  public loadingArtistProducts: boolean = false;
  public loadingGalleryProducts: boolean = false;
  public artistProducts: ArtistProductSummary[] = [];
  public galleryProducts: GalleryPersonlaProduct[] = [];
  public statusFilterOptions: SelectItem[] = [];

  constructor(private route: ActivatedRoute,
    private currencyPipe: CurrencyPipe,
    private router: Router,
    private authService: AuthService,
    private GalleryProductService: GalleryProductService,
    private artistProductsService: ArtistProductsService) { }

  public ngOnInit(): void {
    this.authConfig = this.authService.getAuthConfig();
    if (this.artistId) {
      this.getArtistProductsSummaryResponse(this.artistId, this.filters);
    } else {
      this.getAllGalleryProduct();
    }

    this.statusFilterOptions = [];
    this.statusFilterOptions.push({ label: 'Available', value: 'Available' });
    this.statusFilterOptions.push({ label: 'Consigned', value: 'Consigned' });
    this.statusFilterOptions.push({ label: 'Sold', value: 'Sold' });
  }

private getArtistProductsSummaryResponse(artistId: string, filters: ArtistProductsSummaryRequest) {
  this.loadingArtistProducts = true;

  console.log('===== Fetching Artist Products =====');
  console.log('Artist ID:', artistId);
  console.log('Filters:', filters);

  // Ensure filters include pageSize of 1000 and no status restriction to fetch all products
  const updatedFilters: ArtistProductsSummaryRequest = {
    ...filters
  };

  this.artistProductsService.getArtistProductsSummaryResponse(artistId, updatedFilters).subscribe(
    (artistProducts: ArtistProductSummary[]) => {
      console.log('===== API Response =====');
      console.log('Total products received:', artistProducts.length);
      console.log('Products:', artistProducts);

      this.artistProducts = artistProducts.map((product) => {
        if (product.ArtistRevenue) {
          product.FormattedArtistRevenue = this.currencyPipe.transform(product.ArtistRevenue, 'USD', 'symbol', '1.2-2');
        }
        product.ResizedImageUrl = ImageUtils.getResizedCloudinaryUrl(product.ProductImgUrl || 'assets/images/No-Image.png');
        return product;
      });

      console.log('Filtered products count:', this.artistProducts.length);
      console.log('=============================');

      this.loadingArtistProducts = false;
    },
    (error) => {
      console.error('===== API Error =====', error);
      this.loadingArtistProducts = false;
    }
  );
}

  private getAllGalleryProduct() {
    this.loadingGalleryProducts = true
    this.GalleryProductService.getAllGalleryProduct().subscribe(
      (GalleryProduct) => {
        this.galleryProducts = GalleryProduct;
        this.loadingGalleryProducts = false;

        console.log('GalleryProduct', this.galleryProducts);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  public showProductDetails($event: any, selectedProduct: ArtistProductSummary) {
    $event.stopPropagation();
    // Set sidebarVisible to true when "Show More Detail" is clicked
    this.sidebarVisible = false;
    if (this.authConfig.IsSuperAdmin || this.authConfig.IsAdministrator) {
      this.router.navigate(['/artists', selectedProduct.ArtistId, 'artworks', selectedProduct.Id]);
    } else if (this.authConfig.IsArtist) {
      this.router.navigate(['/artists', 'artworks', selectedProduct.Id]);
    }
    this.onSidebarHidden($event)

  }
  public showGalleryProductDetails($event: any, selectedProduct: GalleryPersonlaProduct) {
    $event.stopPropagation();
    this.sidebarVisible = false;
    this.router.navigate(['/galleries', 'gallery-products', selectedProduct.Id]);
    this.onSidebarHidden($event)

  }

  public onStatusFilterChange($event: any) {
    console.log('===== Status Filter Changed =====');
    console.log('Event:', $event);
    console.log('Selected Status:', $event.value);

    // Update filter status (lowercase 'status' is required by the API)
    this.filters.status = $event.value || undefined;

    console.log('Filters being sent:', this.filters);
    console.log('=============================');

    // Fetch filtered products
    this.getArtistProductsSummaryResponse(this.artistId, this.filters);
  }
  public onSidebarHidden($event: any) {
    this.onClosed.emit();
  }
}
